var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../assets/images/newExcel.svg";
import { hasAuditRole, hasPermission, } from "../../../services/getNavigationPages";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { getAllowedProductIds as getAllowedProductIdsShared } from "ah_utility/fnxUtils";
// Cliente para el que se preseleccionan los estados "Emitida"/"Cotizada"
var APAP_AUTO_SUBDOMAIN = "apap-auto";
var DEFAULT_CHECKED_STATUS_KEYWORDS = ["emitida", "cotizada"];
export var isApapAutoSubdomain = function () {
    return findParamInLocalStorage("subdomain") === APAP_AUTO_SUBDOMAIN;
};
export var getDefaultCheckedStatusItems = function (statusOptions) {
    if (!isApapAutoSubdomain())
        return [];
    return statusOptions.filter(function (item) {
        return DEFAULT_CHECKED_STATUS_KEYWORDS.some(function (keyword) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(keyword); });
    });
};
export var getAllowedProductIds = function () {
    return getAllowedProductIdsShared(APAP_AUTO_SUBDOMAIN);
};
export var getDefaultProjectIds = function () {
    var allowedProductIds = getAllowedProductIds();
    return allowedProductIds ? allowedProductIds.join(",") : "";
};
export var hasProductPermissionRestriction = function () {
    return getAllowedProductIds() !== null;
};
export var NodeType;
(function (NodeType) {
    NodeType["Screen"] = "screen";
    NodeType["Conditional"] = "conditional";
    NodeType["ConditionalRequired"] = "conditionalrequired";
    NodeType["Api"] = "api";
    NodeType["Property"] = "property";
    NodeType["LocalStorage"] = "localstorage";
    NodeType["Next"] = "next";
    NodeType["Previous"] = "previous";
    NodeType["Success"] = "success";
    NodeType["Error"] = "error";
    NodeType["Start"] = "start";
    NodeType["End"] = "end";
    NodeType["Input"] = "input";
})(NodeType || (NodeType = {}));
export var columns = function (handleClickContextMenu) { return [
    {
        field: "actions",
        headerName: "Acciones",
        width: 120,
        renderCell: function (params) {
            var isSinDocument = params.row.code !== "AFU";
            var isStatusEmitida = params.row.status === "Emitida" || isSinDocument;
            if (hasAuditRole()) {
                isStatusEmitida = false;
            }
            var showFinalizarVenta = params.row.status === "Pendiente" &&
                (params.row.code === "SPR" || params.row.code === "NPR");
            // Orden fijo: Ver detalles → Fiscalizar → Finalizar Venta → Cancelar → Historial
            // Los items condicionales se ponen como null y se filtran al final.
            var menuContext = [
                !params.row.isLegacy
                    ? {
                        disabled: !hasPermission("sale-policies-sumary-see-detail"),
                        icon: {
                            color: "#006ac6",
                            icon: icons.Search,
                            size: sizesIcon.standard,
                        },
                        id: "2",
                        name: "Ver detalles",
                    }
                    : null,
                {
                    disabled: isStatusEmitida,
                    icon: {
                        color: "#006ac6",
                        icon: icons.UploadFile,
                        size: sizesIcon.standard,
                    },
                    id: "3",
                    name: "Fiscalizar",
                },
                showFinalizarVenta
                    ? {
                        disabled: !hasPermission("admin-activate-policy"),
                        icon: {
                            color: "#006ac6",
                            icon: icons.CheckCircle,
                            size: sizesIcon.standard,
                        },
                        id: "5",
                        name: "Finalizar Venta",
                    }
                    : null,
                !params.row.isLegacy
                    ? {
                        disabled: !hasPermission("sale-policies-sumary-cancel") ||
                            params.row.status === "Cancelada",
                        icon: {
                            color: params.row.status === "Cancelada" ||
                                params.row.status === "cancelada" ||
                                params.row.status === "Expirada" ||
                                params.row.status === "expirada"
                                ? "#cccccc"
                                : "#d32f2f",
                            icon: icons.Cancel,
                            size: sizesIcon.standard,
                        },
                        id: "1",
                        name: "Cancelar",
                    }
                    : null,
                {
                    disabled: false,
                    icon: {
                        color: "#006ac6",
                        icon: icons.GridView,
                        size: sizesIcon.standard,
                    },
                    id: "4",
                    name: "Historial",
                },
            ].filter(Boolean);
            // isSinDocument (code !== "AFU") excluye Fiscalizar del menú
            var menuContextV = isSinDocument
                ? menuContext.filter(function (item) { return item.id !== "3"; })
                : menuContext;
            return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: menuContextV, onClickContextMenu: function (item) {
                        return handleClickContextMenu(item, params);
                    }, sizeIcon: sizesIcon.standard }) })));
        },
    },
    {
        editable: false,
        field: "status",
        headerName: "Estado",
        renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx("span", { className: params.value }), params.value] }))); },
        width: 100,
    },
    {
        field: "quoteDate",
        headerName: "Fecha Cotización",
        width: 120,
    },
    {
        field: "quotation",
        headerName: "Cotización",
        width: 170,
    },
    {
        field: "issueDate",
        headerName: "Fecha Emisión",
        width: 120,
    },
    {
        field: "certificate",
        headerName: "No. Póliza",
        width: 170,
    },
    {
        field: "firstNameA",
        headerName: "Nombres",
        width: 250,
    },
    {
        field: "lastNameA",
        headerName: "Primer apellido",
        width: 170,
    },
    {
        field: "lastNameB",
        headerName: "Segundo apellido",
        width: 170,
    },
    {
        field: "identification",
        headerName: "Identificación",
        width: 150,
    },
    {
        field: "branch",
        headerName: "Sucursal",
        width: 150,
    },
    {
        field: "userName",
        headerName: "Nombre de usuario",
        width: 200,
    },
    {
        field: "codUser",
        headerName: "Usuario",
        width: 175,
    },
    {
        field: "product",
        headerName: "Producto",
        width: 175,
    },
    {
        field: "insuranceCarrier",
        headerName: "Aseguradora",
        width: 175,
    },
    {
        field: "cancellationDate",
        headerName: "Fecha de cancelación",
        width: 170,
    },
    {
        field: "reasonCancellation",
        headerName: "Motivo de cancelación",
        width: 170,
    },
]; };
export var getFilters = function (insuranceOptions, statusOptions, branchOptions) {
    var defaultCheckedStatusItems = getDefaultCheckedStatusItems(statusOptions);
    var hideInsuranceFilter = hasProductPermissionRestriction();
    var filters = [
        {
            active: true,
            backgroundColor: "#E8EEFF",
            border: true,
            borderRadius: "8px",
            borderType: "1px solid #96ABFF",
            color: "#0D1BD9",
            sizes: "40px",
            type: "fullTextSearch",
        },
        {
            backgroundColor: "#f5f7fa",
            color: "#3a56a1",
            fontWeight: 700,
            label: "Limpiar Filtros",
            type: "cleanButton",
            variantButtons: variants.contained,
            visible: true,
        },
        {
            disabled: !hasPermission("sale-policies-sumary-export"),
            label: "Exportar",
            listButtonDropdown: [
                {
                    icons: icons.DownloadForOffline,
                    id: "1",
                    img: newExcel,
                    name: "Descargar Excel",
                },
            ],
            showImage: true,
            type: "exportButton",
            variantButtons: variants.text,
            visible: true,
        },
        {
            id: "dateRange",
            label: "Rango de fechas",
            type: "dateRange",
        },
        {
            backgroundColor: "#3A56A1",
            color: "#FFFFFF",
            id: "insurance",
            initialSelected: 4,
            listAvatar: insuranceOptions,
            surplus: 2,
            type: "avatarSelection",
            width: "225px",
        },
        __assign(__assign({ dropdownIndex: 1, id: "state", label: "Estado", listDropDown: statusOptions, titleSearch: "Buscar" }, (defaultCheckedStatusItems.length > 0 && {
            defaultCheckedItems: defaultCheckedStatusItems,
        })), { allChecked: false, type: "dropdownMultiple", border: true, borderRadius: "8px" }),
        {
            dropdownIndex: 2,
            id: "branchs",
            label: "Sucursales",
            allChecked: false,
            listDropDown: branchOptions,
            titleSearch: "Buscar",
            type: "dropdownMultiple",
            border: true,
            borderRadius: "8px",
        },
        {
            dropdownIndex: 3,
            id: "isLegacy",
            label: "Tipo de póliza",
            isOneSelection: true,
            listDropDown: [
                { id: "1", active: false, name: "Legacy", value: "true" },
                { id: "2", active: false, name: "Nuevas", value: "false" },
            ],
            titleSearch: "Buscar",
            type: "dropdownMultiple",
            border: true,
            borderRadius: "8px",
        },
    ];
    return hideInsuranceFilter
        ? filters.filter(function (filter) { return filter.id !== "insurance"; })
        : filters;
};
